import React, { useEffect } from 'react';
import { loginRequest } from "../src/auth/authConfig";

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useMsal,useIsAuthenticated,AuthenticatedTemplate,UnauthenticatedTemplate } from "@azure/msal-react";
import { InteractionType,InteractionStatus } from '@azure/msal-browser';

import constants from "./common/restService/constant";
import GatewayGet from "./common/restService/GatewayGet";
import './App.css';

import NCRMHome from './NCRMSHome/Ncrmhome';
import AssignDelegate from './AssignDelegate/AssignDelegate';
import StatusHistory from './StatusHistory/StatusHistory';
import XDOCKSearch from './FGCrossDock/Components/MainComponents/XDOCKSearch';
import FrightOrder from "./FrightOrderSearch/FrightOrderSearch";
import IntelShipRequest from "./IntelShipmentRequest/IntelShipRequest";
import RequestAuthorized from "./IntelShipmentRequest/RequestAuthorized";
import Home from "./Home"
import Qualification from "./Qualification/Qualification";
import CarrierMaster from "./CarrierMaster/CarrierMaster";
import FGSearch from "./FGNCRMSearch/FGSearch";
import Authorization from "./NCRMAuthorization/Authorization";
import ApprovalMatrix from "./ApproverMatrix/ApproverMatrix";
import RFQ from "./RFQ/RFQ.jsx";
import TenderingManager from "./TenderingManager/tenderingMgr";
import CarrierSelTenderingMgr from "./TenderingManager/CarrierSelTenderingMgr";
import InvoiceBidDetails from "./InvoiceBidDetails/InvoiceBidDetails";
import Approver from "./ApproverWorkflow/approver";
import { PageLayout } from './Azure/PageLayout';
import XDOCKMassUpload from "./FGCrossDock/Components/MainComponents/XDockMassUpload";



export default function App() {
    

    const isAuthenticated = useIsAuthenticated();   
    const { inProgress, instance, accounts,none } = useMsal();
    if (inProgress === InteractionStatus.None && !isAuthenticated) {
        setTimeout(() => {
            if (accounts.length === 0) {
                instance.loginRedirect();
            }
        }, 10)
        
      }

    useEffect(()=>{
        var profilelist=sessionStorage.getItem("profile");

        if(isAuthenticated && profilelist==undefined)
  {
        instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
        }).then(async (response) => {
            sessionStorage.setItem("accessToken", response.accessToken);
            sessionStorage.setItem("displayName", accounts[0].name);
            let profile = await getUserData();
            if(profile){
                sessionStorage.setItem("profile", JSON.stringify(profile.RESULT));
                window.location.reload()
            } else{
            }
        });
    }
   
    });

 

   
    let getUserData = async () => {
        let props = {};
        let inputObj = {};
        props["query"] = constants.serviceRoot;
        props["headers"] = constants.serviceHeaders;
        inputObj["Activity"] = "GET_USER_DETAILS";
        inputObj["Input"] = "";
        props.input = inputObj;
        
        return await GatewayGet(props, props.input);
    };
    return (
        <BrowserRouter>
           <PageLayout>
           <Routes>
           <Route  path="/NCRMHome" element={<NCRMHome/>}></Route>
           <Route path="/AssignDelegate" element={<AssignDelegate/>}></Route>
           <Route path="/Approver" element={<Approver/>}></Route>
           <Route path="/Status" element={<StatusHistory/>}></Route>
           <Route path="/FgCrossDock" element={<XDOCKSearch/>}></Route>
           <Route path="/FgCrossDockMassUpload" element={<XDOCKMassUpload/>}></Route>

           {/* <Route path="/FGSearch" element={<FrightOrder />}></Route> */}
           <Route path="/intelshipment" element={<IntelShipRequest />}></Route>
           <Route path="/RequestAuthorized/:any"  element={<RequestAuthorized />}   />
           <Route path="/FrightOrderSearch" element={<FrightOrder />}></Route>
           <Route  path="*"  element={<Home />} />
           <Route path="/prequal" element={<Qualification />}></Route>
           <Route path="/carrier" element={<CarrierMaster />}></Route>
           <Route path="/FGSearch" element={<FGSearch />}></Route>
           <Route path="/ncrmauthorization" element={<Authorization/>}></Route>
           <Route path="/ApprovalMatrix" element={<ApprovalMatrix/>}></Route>
           <Route path="/RFQ" element={<RFQ/>}></Route>
           <Route path="/TenderingMgr" element={<TenderingManager/>}></Route>
           <Route path="/CarrierSelTenderingMgr"element={<CarrierSelTenderingMgr/>}></Route>
           <Route path="/Quotation" element={<InvoiceBidDetails/>}></Route>


           </Routes>
            </PageLayout>
        </BrowserRouter>
     
    );
}
